module.exports = __webpack_public_path__ + "img/Number=64.bbcc0829.png";